import {getQueryParams} from '../utils/helpers';

'use strict';
const _ = require('lodash');

const initialState = {
  page: window.pageName,
  langPref: 'en-US',
  queryParams: getQueryParams(),
  hasPostalSuccess: false,
  hasPostalFailure: false,
  hasValidationError: false,
  errorCode: '',
  errorMessage: ''
};

module.exports = (state = initialState, action) => {
  switch (action.type) {
    case 'POSTAL_SUCCESS':
      return {
        ...state,
        hasPostalSuccess: true,
        hasPostalFailure: false,
        hasValidationError: false
      };
    case 'POSTAL_FAILURE':
      return {
        ...state,
        hasPostalSuccess: false,
        hasPostalFailure: true,
        errorCode: action.code,
        errorMessage: action.message,
      };
    case 'POSTAL_VALIDATION_ERROR':
      return {
        ...state,
        hasPostalSuccess: false,
        hasPostalFailure: false,
        hasValidationError: true,
        errorCode: action.code,
        errorMessage: action.message,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./client/src/reducers/postal.js